import React from "react";
import { Controller, Control, FieldErrors } from "react-hook-form";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { FormControl, FormHelperText, Grid } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {Typography} from "../index"
// import { IDateRangePicker } from "./IDateRangePicker";

export type DateRangePickerProps = {
  control: Control<any>;
  startName: string;
  endName: string;
  labelStart: string;
  labelEnd: string;
  errors?: FieldErrors<any>;
  separator?: string;
  required?: boolean;
  helperTextStart?: string;
  helperTextEnd?: string;
  disablePast?: boolean;
  disableFuture?: boolean;
  fullWidth?: boolean;
};

const DateRangePickerComp: React.FC<DateRangePickerProps> = ({
  control,
  startName,
  endName,
  labelStart,
  separator,
  labelEnd,
  errors,
  required = false,
  helperTextStart,
  helperTextEnd,
  disableFuture,
  disablePast,
  fullWidth = false,
}) => {
  const errorStart = Boolean(errors?.[startName]);
  const errorEnd = Boolean(errors?.[endName]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Grid container spacing={2} >
        <Grid item >
          <FormControl required={required} error={errorStart} fullWidth={fullWidth}>
            <Controller
              name={startName}
              control={control}
              render={({ field }) => (
                <DatePicker
                  {...field}
                  label={labelStart}
                  disablePast={disablePast}
                  disableFuture={disableFuture}
                  value={field.value ? dayjs(field.value, "MM/DD/YYYY") : null}
                  onChange={(date: Dayjs | null) =>
                    field.onChange(date ? dayjs(date).format("MM/DD/YYYY") : null)
                  }
                  slotProps={{ textField: { error: errorStart, required } }}
                  sx={{
                    "& .MuiInputLabel-asterisk": { color: "#F44336" },
                  }}
                />
              )}
            />
            {errorStart && helperTextStart && <FormHelperText>{helperTextStart}</FormHelperText>}
          </FormControl>
        </Grid>
        <Typography sx={{margin: "30px 0px 0px 15px"}}>{separator || "–"}</Typography>
        <Grid item>
          <FormControl required={required} error={errorEnd} fullWidth={fullWidth}>
            <Controller
              name={endName}
              control={control}
              render={({ field }) => (
                <DatePicker
                  {...field}
                  label={labelEnd}
                  disablePast={disablePast}
                  disableFuture={disableFuture}
                  value={field.value ? dayjs(field.value, "MM/DD/YYYY") : null}
                  onChange={(date: Dayjs | null) =>
                    field.onChange(date ? dayjs(date).format("MM/DD/YYYY") : null)
                  }
                  shouldDisableDate={(date) => {
                    const startDate = control._formValues?.[startName];
                    return (
                      startDate &&
                      dayjs(date).isBefore(dayjs(startDate, "MM/DD/YYYY"), "day")
                    );
                  }}
                  slotProps={{ textField: { error: errorEnd, required } }}
                  sx={{
                    "& .MuiInputLabel-asterisk": { color: "#F44336" },
                  }}
                />
              )}
            />
            {errorEnd && helperTextEnd && <FormHelperText>{helperTextEnd}</FormHelperText>}
          </FormControl>
        </Grid>
      </Grid>
    </LocalizationProvider>
  );
};

export default DateRangePickerComp;
